import { useEffect, useState } from "react";
import request from "project-config/services/request/request";
import useForm from "antd/es/form/hooks/useForm";
import { useTranslation } from "react-i18next";
import { VerificationForm } from "../../child-integration-setting/components/verification-form";
import { VerificationFormDetail } from "../../child-integration-setting/components/verification-detail-form";
import { VerificationSettingEchoEnum } from "../constant";
import {
  IVerificationBackProps,
  IVerificationFromProps,
} from "../../child-integration-setting/hooks/useChildIntergrationSettingInfo";
import { useDingTalkSubAccountStore } from "../../../store/dingtalk-subaccount-store";
import Loading from "@/components/Loading";
import styled from "styled-components";

export function useChildIntergrationSettingEcho() {
  const { t } = useTranslation("childManager");
  const [verificationEchoForm] = useForm<IVerificationFromProps>();
  const [verificationBackEchoForm] = useForm<IVerificationBackProps>();
  const { openSettingModal } = useDingTalkSubAccountStore();
  const [loadingData, setLoadingData] = useState(true);
  const [
    defaultVerificationChildTabsList,
    setDefaultVerificationChildTabsList,
  ] = useState([
    {
      label: t("dingtalk_subaccount_echo_tab1"),
      key: VerificationSettingEchoEnum.SETTING,
      children: (
        <VerificationFormDetailWrapper>
          <Loading text={t("dingtalk_subaccount_setting_echo_loading")} />
        </VerificationFormDetailWrapper>
      ),
    },
    {
      label: t("dingtalk_subaccount_echo_tab2"),
      key: VerificationSettingEchoEnum.DOCKING,
      children: (
        <VerificationFormDetailWrapper>
          <Loading text={t("dingtalk_subaccount_setting_echo_loading")} />
        </VerificationFormDetailWrapper>
      ),
    },
  ]);
  const queryDingTalkAppSettings = async () => {
    setLoadingData(true);
    const { data } = await request.post(
      "/api/rendering/user/queryDingTalkAppSettings"
    );
    setLoadingData(false);
    if (!data) return;
    const {
      appKey,
      appSecret,
      aesKey,
      token,
      callbackUrl,
      authCallbackUrl,
      appHomepageUrl,
      enterpriseAlias,
      pcHomepageUrl,
      isValidated,
    } = data;
    verificationEchoForm.setFieldsValue({
      appKey,
      appSecret,
    });
    verificationBackEchoForm.setFieldsValue({
      aesKey,
      token,
      callbackUrl,
      authCallbackUrl,
      appHomepageUrl,
      enterpriseAlias,
      pcHomepageUrl,
      isValidated,
    });
  };

  useEffect(() => {
    if (loadingData) return;
    const currentTabData = [...defaultVerificationChildTabsList];
    currentTabData[0].children = (
      <VerificationFormDetail form={verificationBackEchoForm} />
    );
    currentTabData[1].children = (
      <VerificationForm form={verificationEchoForm} isEchoForm={true} />
    );
    setDefaultVerificationChildTabsList(currentTabData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingData, defaultVerificationChildTabsList]);

  useEffect(() => {
    if (!openSettingModal) return;
    queryDingTalkAppSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSettingModal]);

  return {
    defaultVerificationChildTabsList,
    verificationEchoForm,
  };
}

const VerificationFormDetailWrapper = styled.div`
  position: relative;
  height: calc(100vh - 46px);
`;
